import { translate } from 'App/Internationalization';
import { withProperty } from 'App/Homeowner/PropertyProvider';
import AcceptTransferProperty from 'App/Homeowner/Properties/AcceptTransferProperty';
import AddProperty from 'App/Homeowner/Properties/AddProperty';
import EditProperty from 'App/Homeowner/Properties/EditProperty';
import Page from 'shared/Page';
import paths from 'config/local/paths';
import PropertyScopedPage from 'App/Homeowner/Properties/PropertyScopedPage';
import PropertiesHub from 'App/Homeowner/Properties/PropertiesHub';
import React from 'react';
import Switch from 'shared/Switch';
import TransferProperty from 'App/Homeowner/Properties/TransferProperty';
import { Redirect } from 'react-router-dom';

const InjectedAddProperty = withProperty(AddProperty);

export default function Properties() {
	return (
		<Switch>
			<Page
				component={PropertiesHub}
				exact={true}
				path={paths.app.homeowner.properties.root}
				title={translate('homeowner.pages.properties.root')}
			/>
			<Page
				component={InjectedAddProperty}
				exact={true}
				path={paths.app.homeowner.properties.add}
				title={translate('homeowner.pages.properties.add.title')}
			/>
			<Page
				component={PropertyScopedPage}
				exact={true}
				path={paths.app.homeowner.properties.scoped.details}
				title={translate(
					'homeowner.pages.properties.scoped.submenu.details'
				)}
			/>
			<Page
				component={PropertyScopedPage}
				exact={true}
				path={paths.app.homeowner.properties.scoped.marketValuation}
				title={translate(
					'homeowner.pages.properties.scoped.submenu.market_valuation'
				)}
			/>
			<Page
				component={PropertyScopedPage}
				exact={true}
				path={paths.app.homeowner.properties.scoped.finances}
				title={translate(
					'homeowner.pages.properties.scoped.submenu.finances'
				)}
			/>
			<Page
				component={PropertyScopedPage}
				path={paths.app.homeowner.properties.scoped.documents}
				title={translate(
					'homeowner.pages.properties.scoped.submenu.documents'
				)}
			/>
			<Page
				component={PropertyScopedPage}
				path={paths.app.homeowner.properties.scoped.appliances}
				title={translate(
					'homeowner.pages.properties.scoped.submenu.appliances'
				)}
			/>
			<Page
				component={PropertyScopedPage}
				exact={true}
				path={paths.app.homeowner.properties.scoped.team}
				title={translate(
					'homeowner.pages.properties.scoped.submenu.team'
				)}
			/>
			<Page
				component={PropertyScopedPage}
				exact={true}
				path={paths.app.homeowner.properties.scoped.addPreferredVendor}
				title={translate(
					'homeowner.pages.properties.scoped.submenu.home_pros'
				)}
			/>
			<Page
				component={PropertyScopedPage}
				exact={true}
				path={paths.app.homeowner.properties.scoped.homepros}
				title={translate(
					'homeowner.pages.properties.scoped.submenu.home_pros'
				)}
			/>
			<Redirect
				exact={true}
				from={`${paths.app.homeowner.properties.root}/:propertyId`}
				to={paths.app.homeowner.properties.scoped.marketValuation}
			/>
			<Page
				component={EditProperty}
				path={`${paths.app.homeowner.properties.edit}/:propertyId`}
				title={translate('homeowner.pages.properties.add.title')}
			/>
			<Page
				component={TransferProperty}
				path={paths.app.homeowner.properties.transfer}
				title="Transfer Property"
			/>
			<Page
				component={AcceptTransferProperty}
				path={`${paths.app.homeowner.properties.acceptTransfer}/:propertyId`}
				title="Accept Property Transfer"
			/>
		</Switch>
	);
}
